(() => {
  const root = window.Shopify?.routes?.root || '/';
  const setBusy = (busy) => document.querySelectorAll('[data-shopify-buy]').forEach((box) => {
    box.classList.toggle('is-busy', busy);
    const handle = box.querySelector('.preorder-handle');
    if (handle) handle.disabled = busy;
    const hint = box.querySelector('.preorder-hint');
    if (hint && busy) hint.textContent = 'Apertura checkout…';
  });

  // Short original confirmation chime; independent of the 3D animation.
  let confirmationAudio = null;
  function prepareConfirmationAudio() {
    try {
      const AudioContextType = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextType) return;
      if (!confirmationAudio) confirmationAudio = new AudioContextType();
      if (confirmationAudio.state === 'suspended') confirmationAudio.resume().catch(() => {});
    } catch (_) { /* Audio availability must never interrupt checkout. */ }
  }
  function playConfirmation() {
    try {
      prepareConfirmationAudio();
      if (!confirmationAudio) return;
      const ring = () => {
        const t = confirmationAudio.currentTime + .008;
        [[1318.51, 0, .16], [1760, .075, .22]].forEach(([frequency, offset, duration]) => {
          [1, 2].forEach((harmonic) => {
            const oscillator = confirmationAudio.createOscillator();
            const volume = confirmationAudio.createGain();
            oscillator.type = 'sine';
            oscillator.frequency.value = frequency * harmonic;
            const start = t + offset;
            const peak = harmonic === 1 ? .13 : .025;
            volume.gain.setValueAtTime(0, start);
            volume.gain.linearRampToValueAtTime(peak, start + .004);
            volume.gain.exponentialRampToValueAtTime(.0001, start + duration);
            oscillator.connect(volume);
            volume.connect(confirmationAudio.destination);
            oscillator.start(start);
            oscillator.stop(start + duration + .01);
          });
        });
      };
      if (confirmationAudio.state === 'running') ring();
      else confirmationAudio.resume().then(ring).catch(() => {});
    } catch (_) { /* Keep the existing purchase flow unchanged if sound is unavailable. */ }
  }

  let busy = false;
  async function buy(box) {
    if (busy) return;
    busy = true;
    setBusy(true);
    playConfirmation();
    try {
      const body = new URLSearchParams({ id: box.dataset.variant, quantity: '1' });
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' }, body });
      if (!response.ok) throw new Error('Non è stato possibile aggiungere il prodotto al carrello. Riprova.');
      window.location.assign(`${root}checkout`);
    } catch (error) {
      busy = false;
      setBusy(false);
      const hint = box.querySelector('.preorder-hint');
      if (hint) hint.textContent = error.message || 'Riprova tra poco';
    }
  }
  document.querySelectorAll('[data-shopify-buy]').forEach((box) => {
    const track = box.querySelector('.preorder-track');
    const handle = box.querySelector('.preorder-handle');
    if (!track || !handle) return;
    let startX = 0;
    let max = 0;
    let active = false;
    const reset = () => { active = false; handle.style.transform = ''; };
    handle.addEventListener('pointerdown', (event) => {
      if (busy || event.button !== 0) return;
      prepareConfirmationAudio();
      active = true; startX = event.clientX;
      max = Math.max(0, track.clientWidth - handle.offsetWidth - 12);
      handle.setPointerCapture(event.pointerId);
    });
    handle.addEventListener('pointermove', (event) => {
      if (!active) return;
      const distance = Math.max(0, Math.min(max, event.clientX - startX));
      handle.style.transform = `translateX(${distance}px)`;
      if (distance >= max * .94) { reset(); buy(box); }
    });
    handle.addEventListener('pointerup', reset);
    handle.addEventListener('pointercancel', reset);
    handle.addEventListener('lostpointercapture', reset);
    handle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); buy(box); }
    });
  });
})();
